"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = tslib_1.__importDefault(require("../Button"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
function Inner(_a) {
    var icon = _a.icon, title = _a.title, content = _a.content, prefix = _a.prefix, buttons = _a.buttons, close = _a.close;
    var iconPrefix = utils_1.concat(prefix, 'icon');
    var mainPrefix = utils_1.concat(prefix, 'main');
    var titlePrefix = utils_1.concat(mainPrefix, 'title');
    var contentPrefix = utils_1.concat(mainPrefix, 'content');
    var btnsPrefix = utils_1.concat(mainPrefix, 'btns');
    icon = icon === true ? react_1.default.createElement(icons_1.TipIcon, null) : icon;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        icon && react_1.default.createElement("div", { className: iconPrefix }, icon),
        react_1.default.createElement("div", { className: mainPrefix },
            title && react_1.default.createElement("div", { className: titlePrefix }, title),
            react_1.default.createElement("div", { className: contentPrefix }, content),
            buttons && react_1.default.createElement(Buttons, tslib_1.__assign({ prefix: btnsPrefix, close: close }, (buttons === true ? {} : buttons))))));
}
exports.default = Inner;
function Buttons(props) {
    var langData = ConfigProvider_1.useLangData('modal');
    var prefix = props.prefix, onCancel = props.onCancel, onOk = props.onOk, cancelButtonProps = props.cancelButtonProps, okButtonProps = props.okButtonProps, _a = props.cancelText, cancelText = _a === void 0 ? langData.cancelText : _a, _b = props.okText, okText = _b === void 0 ? langData.okText : _b, close = props.close;
    function handleCancel(event) {
        close();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(event);
    }
    function handleOk(event) {
        close();
        onOk === null || onOk === void 0 ? void 0 : onOk(event);
    }
    return (react_1.default.createElement("div", { className: prefix },
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: "primary", size: "small", onClick: handleOk }, okButtonProps), okText),
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ size: "small", onClick: handleCancel }, cancelButtonProps), cancelText)));
}
//# sourceMappingURL=Inner.js.map